<template>
  <form @keydown.enter.prevent
      id="stock-check-form"
      action="/stock-check"
      method="GET"
  >
    <div class="relative flex w-full md:w-1/2 flex-shrink">
      <input
          aria-label="Search for a part number"
          class="bg-transparent block w-full rounded pl-6 pr-6 sm:text-sm border-2 border-xp-carbon focus:border-black focus:ring-0 uppercase text-sm font-bold tracking-[2.5px] text-black"
          name="part"
          type="search"
          v-model="searchString"
          v-bind:placeholder="placeholder"
          v-on:keyup="searchInputType"
          required
      >
    </div>
  </form>
</template>

<script>
import Hub from '../../events/hub'

export default {
  name: 'StockCheckSearchBox',
  props: {
    part: {
      required: false,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
      default: 'Search for a part number',
    },
  },
  data: () => ({
    searchString: '',
  }),
  mounted() {
    this.searchString = this.part

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const paramValue = params.get('part');
    if (paramValue) {
      this.searchString = paramValue
    }
  },
  methods: {
    searchInputType($event) {
      Hub.$emit('stock-search-input-type', $event.target.value)
    }
  },
}
</script>